/* eslint-disable max-len */
import '../../../assets/css/pages/product.css';
import {
  getPeriod, serverDate, uuid,
} from '../../utils/common';
import { errorMessage } from '../../utils/message';

// 참가 신청 버튼 이벤트
function applicationParticle() {
  const full = getPeriod('full', 'normal');
  const ten = getPeriod('ten', 'normal');
  if ((serverDate() >= full.open && serverDate() <= full.close) && (serverDate() >= ten.open && serverDate() <= ten.close)) {
    // eslint-disable-next-line no-alert
    alert(errorMessage.apply.finish.apply);
    return;
  }

  // eslint-disable-next-line no-restricted-globals
  location.href = uuid
    ? `../apply/part-agree.html?uuid=${uuid}`
    : '../apply/part-agree.html';
}

window.applicationParticle = applicationParticle;
